import { render, staticRenderFns } from "./AllocationRecordDetail.vue?vue&type=template&id=24c41e2a&scoped=true&"
import script from "./AllocationRecordDetail.vue?vue&type=script&lang=js&"
export * from "./AllocationRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./AllocationRecordDetail.vue?vue&type=style&index=0&id=24c41e2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c41e2a",
  null
  
)

export default component.exports